import {
  document_client,
  document_client2,
  get_document,
  get_documents,
  get_documents_institutional,
  get_documents_policy,
  get_plurifonds_document,
  get_plurifonds_documents,
  get_public_document,
  get_public_documents,
  post_delegation_document,
  post_document,
} from 'src/axios/documents.axios'
import { outcome_w } from 'src/backend-codes'
import {
  ax_get_document,
  ax_get_documents,
  ax_get_plurifonds_document,
  ax_get_plurifonds_documents,
  ax_get_public_documents,
  ax_post_document,
  document_t,
  plurifonds_document_pdf_t,
  plurifonds_document_t,
  response_t,
  saga_act,
} from 'src/types'
import { v4 } from 'uuid'

import { do_request } from './base.http'
import axios from 'axios'
import { configify, configify2 } from 'src/axios/base.axios'

/**
 * Resolve documents
 */
export async function http_resolve_documents({
  args,
  type,
}: saga_act<ax_get_documents>): Promise<response_t<document_t[]>> {
  return do_request<document_t[]>({
    client: document_client,
    request: get_documents(v4(), args),
    child: '',
    saga_type: type,
  })
}

/**
 * Resolve plurifonds documents
 */
export async function http_resolve_plurifonds_documents({
  args,
  type,
}: saga_act<ax_get_plurifonds_documents>): Promise<response_t<plurifonds_document_t>> {
  return do_request<plurifonds_document_t>({
    client: document_client,
    request: get_plurifonds_documents(v4(), args),
    child: '',
    saga_type: type,
  })
}

/**
 * Resolve documents policy
 */
export async function http_resolve_documents_policy({
  args,
  type,
}: saga_act<ax_get_documents>): Promise<response_t<document_t[]>> {
  return do_request<document_t[]>({
    client: document_client,
    request: get_documents_policy(v4(), args),
    child: 'documents',
    saga_type: type,
  })
}

/**
 * Resolve documents institutional
 */
export async function http_resolve_documents_institutional({
  args,
  type,
}: saga_act<ax_get_documents>): Promise<response_t<document_t[]>> {
  return do_request<document_t[]>({
    client: document_client,
    request: get_documents_institutional(v4(), args),
    child: 'documents',
    saga_type: type,
  })
}

/**
 * Resolve public documents
 */
export async function http_resolve_public_documents({
  args,
  type,
}: saga_act<ax_get_public_documents>): Promise<response_t<document_t[]>> {
  return do_request<document_t[]>({
    client: document_client,
    request: get_public_documents(v4(), args),
    child: 'documents',
    saga_type: type,
  })
}

/**
 * Download document
 */
export async function http_download_document({
  args,
  type,
}: saga_act<ax_get_document>): Promise<response_t<document_t>> {
  return do_request<document_t>({
    client: document_client,
    request: get_document(v4(), args),
    child: 'document',
    saga_type: type,
  })
}

/**
 * Download plurifonds document
 */
export async function http_download_plurifonds_document({
  args,
  type,
}: saga_act<ax_get_plurifonds_document>): Promise<response_t<plurifonds_document_pdf_t>> {
  return do_request<plurifonds_document_pdf_t>({
    client: document_client,
    request: get_plurifonds_document(v4(), args),
    child: 'document',
    saga_type: type,
  })
}

/**
 * Download public document
 */
export async function http_download_public_document({
  args,
  type,
}: saga_act<ax_get_public_documents>): Promise<response_t<document_t>> {
  return do_request<document_t>({
    client: document_client,
    request: get_public_document(v4(), args),
    child: 'document',
    saga_type: type,
  })
}

/**
 * Send documents
 */
export async function http_send_document({
  args,
  type,
}: saga_act<ax_post_document>): Promise<response_t<outcome_w>> {
  return do_request<outcome_w>({
    client: document_client,
    request: post_document(v4(), args),
    child: 'outcome',
    saga_type: type,
  })
}


/**
 * Upload document
 */
export async function http_upload_document({
  args,
  type,
}: saga_act<any>): Promise<any> {//TODO: change type
  return do_request<outcome_w>({
    client: document_client2,
    request: post_delegation_document(v4(), args),
    child: 'outcome',
    saga_type: type,
  })
}